<template>
  <div
    v-show="show"
    class="fixed inset-0 flex items-center justify-center bg-black/80 z-[999] px-4 backdrop-blur-sm"
  >
    <div
      class="relative w-full max-w-md bg-[#14181F] border border-gray-800 p-8 rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.5)] text-center"
    >
      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-[#FF6B6B] font-oxanium tracking-wide uppercase mb-4 mt-2">
        {{ title }}
      </h2>

      <!-- Error Message -->
      <p class="text-[#B9CACB] text-sm sm:text-base leading-relaxed mb-8">
        {{ message }}
      </p>

      <!-- Close Button -->
      <div class="flex w-full">
        <button
          @click="$emit('close')"
          class="w-full px-6 py-3 bg-[#2A3656] text-white font-bold text-sm rounded-[10px] hover:bg-[#34446b] transition-colors uppercase tracking-wider"
        >
          {{ $t('ErrorModal.Close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Oops! Something went wrong",
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
